import { PanelsService } from '../services/panels.service';
import { EmitterTypes } from '../constants/emitter-types.enum';
import { Subject } from 'rxjs/Subject';
import {Component, OnDestroy} from '@angular/core';

@Component({
    template: ''
})
export abstract class LayoutLoaderAbstract implements OnDestroy {
  protected _panelService: PanelsService;

  protected destroyer: Subject<any> = new Subject();

  constructor(_panelService: PanelsService) {
    this._panelService = _panelService;

  }


  abstract onNext(result);

  abstract onError(err);

  abstract onComplete();

  public initListener(name) {
    this._panelService.registerObservable(name)
      .takeUntil(this.destroyer.asObservable())
      .filter(value => value.emitter !== EmitterTypes.parent)
      .subscribe(
        (data) => this.onNext(data),
        err => this.onError(err),
        () => this.onComplete(),
      );
  }

  protected dismiss(name) {
    this._panelService.dismissObservable(name);
  }

  ngOnDestroy(): void {
    this.destroyer.complete();
  }

}
